import { useState } from 'react';
import './index.css';
import TabSwitcher from '../../molecules/TabSwitcher/view';
import AccountsSummaryTable from '../../organisms/AccountsSummaryTable/view';
import ButtonGroup from '../../molecules/buttonGroup/view';
const AccountsManagement = () => {
    const [activeTabIndex, setActiveTabIndex] = useState(window.location.hash === '#cxp' ? 1 : 0);

    const tabs = [
        {
            name: "Cuentas por Cobrar (CXC)",
            component: () => (
                <AccountsSummaryTable type="receivable" />
            ),
        },
        {
            name: "Cuentas por Pagar (CXP)",
            component: () => (
                <AccountsSummaryTable type="payable" />
            ),
        }
    ];

    return (
        <>
            <ButtonGroup
                title="Cartera (CXC/CXP)"
                description="Controla tus saldos pendientes de clientes y pagos a proveedores."
            />
            <TabSwitcher tabs={tabs} activeTabIndex={activeTabIndex} onTabChange={setActiveTabIndex} hashKey="tab" />
        </>
    );
};

export default AccountsManagement;
